import { Provider, atom, useAtom } from 'jotai'
import { atomWithReset } from 'jotai/utils'

export const step1DataAtom = atom({
  prodCateId: '', // 分类id
  prodName: '', // 产品名称
  attachList: [], // 产品详情列表
  prodType: '', // 产品类型
  mainFiles: [], // 图片
  imageUrls: [], // 图片链接
  bizTag: '', // 需求标签
  brandId: '', // 品牌
  packModelId: '', // 打包模版id
  pmsSerId: '', // 产品服务
  specialCode: '', // 特项代码
  skuList: [], // 打包模板对应sku列表
  specificationArgList: [], // 打包模板对应规格列表
  treeNodes: [], // 打包树
  combinationInfo: [],// 组合产品
  priceItems: [], //费用项
  unitInfo: {}, // 单位
  sourceType: 'SELF', // 来源
  costTemplateId: '',
});

export const step2DataAtom = atomWithReset({
  config: [],
  notStandardConfig: [],
  skuList: [],
  skuTableColumns: [],
  argsJsonList: [],
  skuByArgs: [], // 参数数组
  createModes: [1], // 0新增 1 叠加 2打包
  specificationArgList: [], // 规格参数-及使用值
  argList: [], // 非规格参数-及使用值
});

export const step3DataAtom = atomWithReset({
  capitalQuoteFlag: false,
  capitalDesc: '',
  allowRefund: true,
  productCapitalSpecials: [],
  deductivePricingType: '', // 减项计价方式
  discountAmount: '', // 折扣数
  decimalPrecision: '', // 小数精度
  roundingRule: '', // 取数规则
});

export const stepOptionDataAtom = atomWithReset({
  specialCodeList: [], // 特项代码列表
});

export const stepCommonDataAtom = atomWithReset({
  id: '',
  packModelType: '', // 打包模板类型
  chooseTimeType: '', // 打包模板可选材时间
  capitalQuoteFlag: false,
});

